export default __webpack_public_path__ + "static/media/jodhjeet_singh.390a39b1.jpeg";